import { render } from "./ContentRenderer.vue?vue&type=template&id=d46ad958"
import script from "./ContentRenderer.vue?vue&type=script&lang=js"
export * from "./ContentRenderer.vue?vue&type=script&lang=js"
script.render = render

export default script